import { render, staticRenderFns } from "./ChangePasswordDialog.vue?vue&type=template&id=34bfab0c"
import script from "./ChangePasswordDialog.vue?vue&type=script&lang=js"
export * from "./ChangePasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordDialog.vue?vue&type=style&index=0&id=34bfab0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports